import { render, staticRenderFns } from "./CollapsibleDescriptionNew.vue?vue&type=template&id=84096b0c"
import script from "./CollapsibleDescriptionNew.vue?vue&type=script&lang=ts"
export * from "./CollapsibleDescriptionNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84096b0c')) {
      api.createRecord('84096b0c', component.options)
    } else {
      api.reload('84096b0c', component.options)
    }
    module.hot.accept("./CollapsibleDescriptionNew.vue?vue&type=template&id=84096b0c", function () {
      api.rerender('84096b0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/CollapsibleDescriptionNew.vue"
export default component.exports